<template>
  <!-- Start Services Area -->
  <section class="services-area-two ptb-80 bg-f7fafd">
    <div class="container">
      <div class="section-title">
        <h2>Our Services</h2>
      </div>

      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="single-services-box">
            <div class="icon">
              <feather type="settings"></feather>
            </div>

            <h3>Business Solutions</h3>
            <p>
              Interactive is committed to delivering reliable, easy-to-use, and easy-to-maintain business solutions.
              <br />
              <br />Interactive IT and infrastructure solutions are designed and implemented to maximize efficiency,
              reduce duplication, enhance data security, and minimize workflow disruptions. Software, web, and database
              applications will meet the demands of your business while enhancing the speed and integrity of your workflow process.
              <br />
              <br />
              <br />
            </p>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="single-services-box">
            <div class="icon bg-c679e3">
              <feather type="grid"></feather>
            </div>

            <h3>Professional Services</h3>
            <p>
              Interactive will provide the services that you need to increase productivity, reduce cost, and improve data security.
              <br />
              <br />Interactive Professional Services include comprehensive business services, such as workflow analysis, quality improvement,
              product management, PCI compliance, and automation, as well as project-specific services, such as project estimation, data recovery, technology selection consultation, and project management.
              <br />
              <br />
              <br />
            </p>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="single-services-box">
            <div class="icon bg-eb6b3d">
              <feather type="send"></feather>
            </div>

            <h3>IT Infrastructure</h3>
            <p>
              Interactive provides infrastructure consultation, cost estimation, equipment ordering and preparation, equipment installation,
              system testing, and system integration services for any business.
              <br />
              <br />Interactive will assess the infrastructure needs of your business through a comprehensive analysis of business operations
              from entry level to executive and make recommendations that will accomplish your goals of increased productivity, reduced cost, and improved data security.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- End Services Area -->
</template>

<script>
export default {
  name: "Services"
};
</script>